import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    franchiseAgentProduct: null,
    franchiseAgentProducts: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const franchiseAgentProductReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.FRANCHISEAGENTPRODUCT_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.FRANCHISEAGENTPRODUCT_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.FRANCHISEAGENTPRODUCT_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        case actionTypes.FRANCHISEAGENTPRODUCT_RESET: {
            return updateState(state, { ...action.data, lastState: constants.STATE_RESET, lastScope: 'reset' });
        }
        default: {
            return state;
        }
    }
};

export default franchiseAgentProductReducer;
